module.exports = __webpack_public_path__ + "img/vinyl-fill.82ac0158.svg";